import React, { useState, useEffect, useCallback, useRef } from 'react';
import { billingService } from '../services/subscriptionService';
import { useSubscription } from '../providers/SubscriptionProvider';
import { navigateToSubscribe } from '../utils/billingHandoff';
import { isIosShell } from '../utils/platform';
import { resolveTrialBannerView } from '../utils/trialBannerCopy';

const GOLD = '#C9A84C';

export default function TrialBanner() {
  if (isIosShell()) return null;
  const { openStripeCheckout } = useSubscription();
  const [view, setView] = useState({ kind: 'hidden' });
  const [busy, setBusy] = useState(false);
  const pollRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const data = await billingService.getBillingStatus();
      if (cancelled) return;
      const next = resolveTrialBannerView(data);
      setView(next);
      if (data?.status === 'active' && pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    };

    check();
    pollRef.current = setInterval(check, 60000);
    return () => { cancelled = true; if (pollRef.current) clearInterval(pollRef.current); };
  }, []);

  const handleSubscribe = useCallback(async () => {
    setBusy(true);
    try {
      const ok = await openStripeCheckout('monthly');
      if (!ok) navigateToSubscribe({ resubscribe: '1' });
    } finally {
      setBusy(false);
    }
  }, [openStripeCheckout]);

  if (view.kind === 'hidden') return null;

  return (
    <div
      style={{
        padding: '10px 16px',
        background: 'rgba(201, 168, 76, 0.08)',
        borderBottom: '1px solid rgba(201, 168, 76, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      <span style={{ fontSize: 13, color: GOLD, fontWeight: 600 }}>
        {view.message}
      </span>
      {view.showSubscribe && (
        <button
          onClick={handleSubscribe}
          disabled={busy}
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: GOLD,
            background: 'none',
            border: `1px solid ${GOLD}`,
            borderRadius: 20,
            padding: '5px 14px',
            cursor: busy ? 'wait' : 'pointer',
            transition: 'opacity 0.15s',
            whiteSpace: 'nowrap',
            opacity: busy ? 0.7 : 1,
          }}
        >
          {busy ? 'Opening…' : 'Subscribe now →'}
        </button>
      )}
    </div>
  );
}
